import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import mixpanel from "mixpanel-browser";
import Modal from "react-modal";
import DropdownMenu, { DropdownMenuItem } from "../../../ui-components/dropdown-menu/dropdownMenu";
import UserState from "../../../slices/user/UserState";
import {
  closeMobileSideMenu,
  logout,
  userSelector
} from "../../../slices/user/userSlice";
import XGSIcon from "../../../ui-components/icon/xgsIcon";
import XGSIcons from "../../../ui-components/icon/xgsIcons";
import { Routes } from "../../../app/route/RoutesConfig";
import { UserUtils } from "../../../app/data/user/userUtils";
import ContactUs from "../../contact-us/contactUs";
import Userpick from "./userpick";
import modalStyle from "../../../app/data/common/modalStyle";
import { ReactComponent as GearIcon } from "../../../images/gear.svg";
import { ReactComponent as ContactIcon } from "../../../images/contact.svg";
import { ReactComponent as CompanyIcon } from "../../../images/company.svg";
import { ReactComponent as LogoutIcon } from "../../../images/logout.svg";
import { ReactComponent as CrossGrayIcon } from "../../../images/cross_gray.svg";
import { ReactComponent as IosIcon } from "../../../images/ios.svg";
import { ReactComponent as AndroidIcon } from "../../../images/android.svg";
import "./userMenu.scss";

const SAFARI_INSTRUCTIONS = [
  "Open Safari and go to [my.xgsi.com/one.xgsi.com]",
  "Tap the Share icon",
  'Select "Add to Home Screen”',
  "Tap Add",
];

const CHROME_INSTRUCTIONS = [
  "Open Chrome and go to [my.xgsi.com/one.xgsi.com]",
  "Tap the : Menu icon (top-right)",
  'Choose "Add to Home Screen"',
  "Tap Add",
];

const MobileIcon = ({ className = "" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 21 24"
    fill="none"
    className={`mobile-icon ${className}`}
  >
    <path
      d="M15.9645 17.7369V15.8551H14.4952V17.7369H12.7073V19.2063H14.4952V21.0882H15.9645V19.2063H17.7525V17.7369H15.9645Z"
      fill={'#4F5F72'}
      fillOpacity="0.72"
    />
    <path
      d="M18.5578 14.0554C17.593 13.3279 16.4429 12.9432 15.2319 12.9432C15.1409 12.9432 15.0487 12.9456 14.9501 12.9506C14.8588 12.9552 14.7675 12.9624 14.6764 12.9716V0H0V21.8228H10.8365C11.8803 23.193 13.4947 24 15.2319 24C18.2803 24 20.7604 21.52 20.7604 18.4716C20.7604 16.7206 19.9576 15.111 18.5578 14.0554ZM1.46939 1.46939H13.207V3.18464H1.46939V1.46939ZM1.46939 20.3534V18.5491H9.70528C9.70936 18.8347 9.73491 19.1229 9.78356 19.4073C9.82153 19.6294 9.8723 19.8476 9.93445 20.0557C9.95123 20.112 9.96923 20.168 9.98784 20.2238C9.99361 20.241 9.99975 20.2581 10.0057 20.2753C10.0147 20.3013 10.0233 20.3275 10.0327 20.3534H1.46939ZM9.88008 17.0798H1.46939V4.65403H13.207V13.3261C13.2046 13.3271 13.2022 13.328 13.1998 13.329C13.1578 13.3456 13.1165 13.3635 13.0752 13.3814L13.0477 13.3933C12.7676 13.5141 12.4989 13.6566 12.2489 13.8172C11.0567 14.5826 10.2241 15.7491 9.88008 17.0798ZM15.2319 22.5306C13.8562 22.5306 12.5849 21.8413 11.831 20.6864L11.8083 20.6521C11.6409 20.39 11.5052 20.1103 11.4027 19.8189C11.3812 19.7581 11.3608 19.697 11.3424 19.6352C11.2971 19.4836 11.2599 19.3236 11.2319 19.1596C11.1928 18.9311 11.173 18.6996 11.173 18.4716C11.173 17.0831 11.872 15.8054 13.0428 15.0536C13.2255 14.9363 13.4228 14.8317 13.6296 14.7425L13.6612 14.7289C13.6875 14.7174 13.7139 14.7058 13.7405 14.6953C13.7894 14.6759 13.8401 14.6575 13.8918 14.6397C13.9716 14.6121 14.054 14.5861 14.1389 14.5624C14.4283 14.4818 14.7269 14.4331 15.024 14.4181C15.0977 14.4145 15.1658 14.4127 15.2321 14.4127C16.1213 14.4127 16.9654 14.6948 17.6733 15.2287C18.7015 16.004 19.2912 17.1861 19.2912 18.4717C19.291 20.7098 17.4701 22.5306 15.2319 22.5306Z"
      fill={'#4F5F72'}
      fillOpacity="0.72"
    />
  </svg>
);

const UserMenu: React.FC<{}> = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const userState: UserState = useSelector(userSelector);
  const [opened, setOpened] = useState<boolean>(false);
  const [unblocked, setUnblocked] = useState<boolean>(true);
  const [contactUsPopup, setContactUsPopup] = useState<boolean>(false);
  const [showModal, setShowModal] = useState<boolean>(false);

  const menuItems: DropdownMenuItem[] = [
    {
      text: "Settings",
      to: Routes.settings,
      onClick: () => {
        closeDropdown();
        dispatch(closeMobileSideMenu());
      },
      iconComponent: <GearIcon />,
    }
  ];

  if (UserUtils.isAdministrator(userState.profile)) {
    menuItems.push({
      text: "Company",
      to: Routes.company.general,
      onClick: () => {
        closeDropdown();
        dispatch(closeMobileSideMenu());
      },
      iconComponent: <CompanyIcon />,
    });
  }

  if (UserUtils.isAdministrator(userState.profile) || UserUtils.isUser(userState.profile)) {
    menuItems.push({
      text: "Contact Us",
      onClick: () => {
        closeDropdown();
        dispatch(closeMobileSideMenu());
        setContactUsPopup(true);
      },
      iconComponent: <ContactIcon />,
    });
  }

  menuItems.push({
    text: "Log out",
    onClick: () => {
      dispatch(closeMobileSideMenu());
      if (userState.profile?.impersonated) {
        localStorage.removeItem("xgs-impersonate-token");
        history.push(Routes.home);
        window.location.reload();
      } else {
        setTimeout(() => {
          mixpanel.track("Logged Out", { "Reason": "Click on the profile menu item" });
          mixpanel.reset();
          dispatch(logout());
        }, 100);
      }
    },
    iconComponent: <LogoutIcon />,
  });

  const openDropdown = () => {
    if (!unblocked) return;
    setUnblocked(false);
    setOpened(true);
  };

  const closeDropdown = () => {
    setOpened(false);
    setTimeout(() => setUnblocked(true), 150);
  };

  const onMobileIconClick = () => {
    setShowModal(true);
  };
  const InstructionList = ({ title, icon, steps }: { title: string; icon: React.ReactNode; steps: string[] }) => {
    return (
      <div className="home-screen-instructions__list">
        <div className="home-screen-instructions__list__header">
          <div className="home-screen-instructions__list__header__icon">
            {icon}
          </div>
          <span>{title}</span>
        </div>
        {steps.map((step, index) => (
          <div key={index} className="home-screen-instructions__list__step">
            {index + 1}. {step}
            <br />
          </div>
        ))}
      </div>
    );
  };

  const InfoBlock = () => {
    return (
      <div className="home-screen-instructions__info">
        Once added, you can access MyXGS/OneXGS from your home screen.
      </div>
    );
  };

  return (
    <div className="xgs-user-menu">
      <div className="xgs-user-menu__mobile-icon">
        <div className="xgs-user-menu__mobile-icon__trigger" onClick={onMobileIconClick}>
        <MobileIcon/>
        </div>
        <div className="xgs-user-menu__trigger" onClick={openDropdown}>
          <div className="xgs-user-menu__user xgs-user-menu__user--normal">
            <div className="xgs-user-menu__user__info">
              <Userpick profile={userState.profile} />
              <div>
                <div className="xgs-user-menu__user__info-item">
                  {userState.profile?.firstName} {userState.profile?.lastName}
                </div>
                {userState.profile?.team?.name && (
                  <div className="xgs-user-menu__user__info-item xgs-user-menu__user__team" title={userState.profile.team.name}>{userState.profile.team.name}</div>)}
              </div>
            </div>
          </div>
          <div className="xgs-user-menu__user xgs-user-menu__user--short">
            <Userpick profile={userState.profile} />
          </div>
          <span className="xgs-user-menu__arrow">
            <XGSIcon icon={opened ? XGSIcons.faChevronUp : XGSIcons.faChevronDown} />
          </span>
        </div>
      </div>
      <DropdownMenu
        menuItems={menuItems}
        opened={opened}
        onClose={closeDropdown}
      />
      <ContactUs
        onClose={() => setContactUsPopup(false)}
        showPopup={contactUsPopup}
      />
      <Modal
        isOpen={showModal}
        style={modalStyle}
        shouldCloseOnOverlayClick={false}
        shouldCloseOnEsc={false}
      >
        <div className="home-screen-instructions__close">
          <CrossGrayIcon onClick={() => setShowModal(false)} />
        </div>
        <div className="home-screen-instructions__header">
          <strong>Add to Home Screen</strong>
        </div>
        <div className="home-screen-instructions__content">
          <InstructionList
            title="For iPhone & iPad (Safari)"
            icon={<IosIcon style={{ width: "13.6px", height: "13.6px" }} />}
            steps={SAFARI_INSTRUCTIONS}
          />
          <InstructionList
            title="For Android (Chrome)"
            icon={<AndroidIcon style={{ width: "13.6px", height: "13.6px" }} />}
            steps={CHROME_INSTRUCTIONS}
          />
          <InfoBlock />
        </div>
      </Modal>
    </div>
  );
}

export default UserMenu;